import '@archetype-themes/scripts/config';
import { Slideshow } from '@archetype-themes/scripts/modules/slideshow';

class ShAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.sectionId = this.container.getAttribute('data-section-id');

    this.addEventListener('shopify:block:select', this.onBlockSelect);
    this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

    this.args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: 'center',
      fade: false
    };
    this.bar = null;
    this.flickity = null;
  }

  connectedCallback() {
    this.bar = document.getElementById('SHAnnouncementSlider');
    if (!this.bar) {
      return;
    }

    this.unload();

    document.dispatchEvent(
      new CustomEvent('sh-announcement-section:loaded', {
        detail: {
          sectionId: this.sectionId
        }
      })
    )

    if (this.bar.dataset.blockCount === 1) {
      return;
    }

    this.flickity = new Slideshow(this.bar, this.args);
  }

  onBlockSelect(id) {
    const slide = this.bar.querySelector('#AnnouncementSlide-' + id);
    const index = parseInt(slide.dataset.index);

    if (this.flickity && typeof this.flickity.pause === 'function') {
      this.flickity.goToSlide(index);
      this.flickity.pause();
    }
  }

  onBlockDeselect() {
    if (this.flickity && typeof this.flickity.play === 'function') {
      this.flickity.play();
    }
  }

  disconnectedCallback() {
    this.unload();
  }

  unload() {
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy();
    }
  }
}

customElements.define('sh-announcement-bar-section', ShAnnouncementBar);
